import { Component, OnInit, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { BillingInvoiceAssociateFilter } from '../../../model/billing/billing-invoice-associate-filter';
import { FormGroup, FormBuilder, ControlValueAccessor } from '@angular/forms';
import { ValidateAutoCompleteSelect } from '../../../validators/autocomplete-select.validator';
import { BillingInvoiceAssociateService } from '../../../services/billing/billing-invoice-associate.service';
import { Observable } from 'rxjs';
import { switchMap, filter, debounceTime, tap, finalize } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-billing-invoice-associate-auto-complete',
  templateUrl: './billing-invoice-associate-auto-complete.component.html'
})
export class BillingInvoiceAssociateAutoCompleteComponent implements OnInit, ControlValueAccessor {

  onChange;
  filteredSearchFilter: Observable<BillingInvoiceAssociateFilter[]>;
  form: FormGroup;
  billingInvoiceAssociatecFilters: BillingInvoiceAssociateFilter[] = [];
  selecting: boolean;
  loading: boolean;
  @ViewChild('invoiceSearchCtrl', {static: false}) invoiceSearchCtrl: ElementRef;
  @Output() invoiceAssociateChange = new EventEmitter();


  constructor(private formBuilder: FormBuilder
    , private datePipe: DatePipe
    , private biaService: BillingInvoiceAssociateService) {

    this.form = this.formBuilder.group({
      BillingInvoiceAssociate: [ null, ValidateAutoCompleteSelect ]
    });
  }

  get f() { return this.form.controls; }

  displayFn(item?: BillingInvoiceAssociateFilter): string | undefined {

  const date = new Date(item.InvoiceDate);
  // formato dd/MM/yyyy
  const fecha = date.toLocaleDateString('es-AR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

    return item ? `${ item.Number }  ${ fecha }  ${ item.BusinessName }` : undefined;
  }

  ngOnInit() {

    this.f.BillingInvoiceAssociate.valueChanges.pipe(
      filter(value => {
        if (value != null && value !== '' && Number(value)) {
          return true;
        } else {
          if (value == null || value === '') {
            this.billingInvoiceAssociatecFilters = [];
          }
          return false;
        }
      }),
      debounceTime(400),
      tap(() => this.loading = true),
      switchMap(value => this.biaService.getBillingInvoiceAssociateFilters(value)
        .pipe(finalize(() => this.loading = false), ))
    ).subscribe(values => this.billingInvoiceAssociatecFilters = values);
  }

  billingInvoiceAssociateFilterSelected( filter: BillingInvoiceAssociateFilter) {
    this.selecting = true;
    this.form.patchValue({ BillingInvoiceAssociate: filter });
    this.onBillingInvoiceAssociateChange();
  }

  onBillingInvoiceAssociateChange() {

    const value =  !this.form.valid ?
      null : this.form.controls.BillingInvoiceAssociate.value;
    if ( this.onChange ) {
      this.onChange( value );
    }
    this.invoiceAssociateChange.emit( value );
  }

  writeValue(obj: any): void {

    this.form.patchValue({ ClientsSearchCtrl: obj });
  }

  registerOnChange(fn: any): void {

    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {

  }

  setDisabledState?(isDisabled: boolean): void {

    if (isDisabled) {
      this.form.disable();
    }
  }
}
